import { render, staticRenderFns } from "./ScheduleItems.vue?vue&type=template&id=49ee8d16&"
import script from "./ScheduleItems.vue?vue&type=script&lang=js&"
export * from "./ScheduleItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports